const switchClientsActionTypes = {
  RESET_STATE: 'RESET_STATE',
  SET_ASSOCIATES: 'SET_ASSOCIATES',
  SET_ACTIVE_ASSOCIATE_REQUEST: 'SET_ACTIVE_ASSOCIATE_REQUEST',
  SET_ACTIVE_ASSOCIATE_SUCCESS: 'SET_ACTIVE_ASSOCIATE_SUCCESS',
  SET_ACTIVE_ASSOCIATE_FAILURE: 'SET_ACTIVE_ASSOCIATE_FAILURE',
};

export { switchClientsActionTypes as default };
